module.exports = __webpack_public_path__ + "static/media/frontcover.2f1ef55e.jpg";